// import { useState } from "react";
import { useSelector } from "react-redux";

function useLangTranslation() {
  const { translationLangList } = useSelector(({ misc }) => misc);

  return {
    getLangTranslation: function (key, value) {
      for (let i = 0; i < translationLangList?.length; i++) {
        if (
          translationLangList[i]["TranslationLabel"]?.trim() === key?.trim()
        ) {
          return translationLangList[i]["TranslationText"]?.trim();
        }
      }

      // return value ?? key;
      return key;
    },
  };
}

export default useLangTranslation;
